import React, {useState} from 'react';

function PasswordGenerator(props) {
    document.title = props.title;

    const [password, setPassword] = useState('');

    const notEmpty = () => {
        let password = document.getElementById("password");
        if(password.value !== ""){
            let iconChange = document.getElementById("iconChange");
            iconChange.className = "bi bi-clipboard";
        }
    }
    
    const generateFunnyPassword = () => {
        notEmpty();
        let items = ["bullet", "gun", "pistol", "hahaha", "hehehe", "yahuuu", "waoooo", "kill", "destroy"];
        setPassword(items[Math.floor(Math.random() * items.length)]);
    }

    const generateStrongPassword = () => {
        notEmpty();
        let length = 12,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
        for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        setPassword(retVal);
    }

    const generateWeakPassword = () => {
        notEmpty();
        let length = 5,
        charset = "abc",
        retVal = "";
        for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        setPassword(retVal);
    }

    const generateSuperStrongPassword = () => {
        notEmpty();
        let length = 30,
        charset = `abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+-=|][{}';:"/.>?,<'`,
        retVal = "";
        for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        setPassword(retVal);
    }

    const copyPassword = () => {
        let password = document.getElementById("password");
        let iconChange = document.getElementById("iconChange");
        let passwordCopied = document.getElementById("passwordCopied");
        navigator.clipboard.writeText(password.value);
        iconChange.className = "bi bi-clipboard-check text-success";
        passwordCopied.style.display = "block";
        setTimeout(()=>{
            passwordCopied.style.display = "none";
        }, 3000)
    }
    
    return (
        <>
            <span id="passwordCopied">Password Copied!</span>
            <div className='row text-center mb-5'>
                <div className="col-8 mx-auto">
                    <div className="row">
                        <div className="col-12 position-relative">
                            <input type="text" name="password" placeholder='Click Below Button to Generator Password' id="password" value={password} className='form-control mb-3 d-inline' disabled /> 
                            
                            {password === "" ? (
                                ""
                            ) : (
                                <>
                                <span className='copyBtn'><button className='btn btn-link' onClick={copyPassword}><i class="bi bi-clipboard" id="iconChange"></i></button></span>
                                </>
                            )}

                        </div>
                    </div>
                    <button className="btn btn-dark mx-2 my-2" onClick={generateFunnyPassword}>Funny Password</button>
                    <button className="btn btn-dark mx-2 my-2" onClick={generateWeakPassword}>Weak Password</button>
                    <button className="btn btn-dark mx-2 my-2" onClick={generateStrongPassword}>Strong Password</button>
                    <button className="btn btn-dark mx-2 my-2" onClick={generateSuperStrongPassword}>Super Strong Password</button>
                </div>
            </div>
        </>
    )
}

export default PasswordGenerator
